import { render, staticRenderFns } from "./TopupWallet.vue?vue&type=template&id=19e8f796&"
import script from "./TopupWallet.vue?vue&type=script&lang=js&"
export * from "./TopupWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports